import * as React from "react";
import styled, { css } from "../../../styled/index";
import {CS} from "../../../styles/index";

const WrapperComponent = styled("menu")<{ noTopOffset?: boolean; }>`
  overflow: auto;
  position: fixed;
  z-index: ${({theme}) => theme.side_nav.zindex};
  display: block;
  top: ${({noTopOffset, theme}) => noTopOffset ? 0 : theme.top_nav.height}px;
  left: 0;
  bottom: 0;
  width: ${({theme}) => theme.side_nav.width}px;
  background: ${({theme}) => theme.side_nav.background_color};
  ${CS.shadow.light.two};
`;

const ContentComponent = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 20px 14px;
  width: 100%;
  > * {
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0
    }
  }
`;

export interface SideNavProps {
  noTopOffset?: boolean;
  children?: React.ReactNode | React.ReactNode[];
}

export const SideNav = (props: SideNavProps) => (
  <WrapperComponent noTopOffset={props.noTopOffset}>
    <ContentComponent>
      {props.children}
    </ContentComponent>
  </WrapperComponent>
);
